import { AlertConstants } from "../types/alert";
import { BrandTheme } from "../types/brand";

export const ALERT: AlertConstants = {
  invalidJWTMsg: "Your session has expired. Please login to continue",
  invalidSessionMsg: "Authentication token expired, Please login again",
  invalidJWTCode: 6,
  invalidSessionCode: 1,
};

export const defaultTheme: BrandTheme = {
  themeName: "dark",
  pageBackground: "rgb(235, 236, 245)",
  secondaryBackground: "rgb(0, 59, 130)",
  secondaryText: "rgb(239, 229, 46)",
  fadedBackground: "rgba(17, 23, 29, 0.5)",
  defaultText: "#000",
  black: "#000",
  defaultButtonText: "rgba(43, 44, 44, 1)",
  disabledBtn: "rgba(43, 44, 44, 0.2)",
  defaultButtonBg: "rgba(237, 239, 240, 1)",
  selected: "rgb(1, 248, 131)",
  pillText: "#FFF",
  lineBreak: "rgb(30, 42, 58)",
  probabilityHighlight: "rgb(68, 219, 94)",
  selectedPill: "rgba(7, 64, 145, 1)",
  selectedText: "#FFF",
  pillBackground: "rgba(237, 239, 240, 1)",
  yellow: "rgb(239, 229, 46)",
  formLoss: "rgb(231, 32, 53)",
  formDraw: "rgb(239, 229, 46)",
  formWin: "rgb(68, 219, 94)",
  push: "rgba(182, 203, 216, 1)",
  statsFormLoss: "rgb(70, 39, 57)",
  statsFormDraw: "rgb(72, 79, 55)",
  statsFormWin: "rgb(38, 77, 65)",
  indicator: "rgb(56, 66, 77)",
  facebook: "rgb(59, 89, 152)",
  twitter: "rgb(85, 172, 238)",
  platinum: "rgb(225, 225, 225)",
  tip: "rgb(24, 60, 97)",
  tipBorder: "rgb(2, 137, 255)",
  statCardBackground: "rgb(30, 42, 58)",
  statScoreText: "rgb(19, 31, 46)",
  discoverGreen: "rgb(38, 77, 65)",
  discoverYellow: "rgb(72, 79, 55)",
  discoverSignedIn: "rgb(61, 64, 32)",
  bestOdds: "rgb(30, 69, 54)",
  white: "rgb(255, 255, 255)",
  flashpicksBlue: "rgb(5, 47, 107)",
  lightGrey: "rgb(182, 203, 216)",
  backgroundGrey: "rgb(230, 234, 240)",
  hrColor: "rgba(237, 239, 240, 1)",
  dimGrey: "rgba(102, 102, 102, 1)",
  paleAqua: "rgba(205, 217, 233, 1)",
  smalt: "rgba(7, 63, 145, 1)",
  midnightBlue: "rgba(6, 47, 107, 1)",
  darkMidnightBlue: "rgba(5, 47, 107, 0.08)",
  darkGray: "rgba(170, 171, 171, 1)",
  sepColor: "rgba(182, 203, 216, 1)",
  alertBackground: "rgba(7, 64, 145, 1)",
  logoGreen: "rgba(61,216,76)",
  NBA: "rgba(39, 65, 133)",
  NFL: "rgba(19, 50, 101)",
  NHL: "rgba(17, 17, 17)",
  MLB: "rgba(13, 30, 64)",
  segmentedControlBackground: "rgba(118, 118, 128, 0.12)",
  taupeGrey: "rgba(142, 142, 147, 1)",
};

export const SPORTS_MAP = new Map([
  ["NBA", "Basketball"],
  ["NHL", "Ice Hockey"],
  ["MLB", "Baseball"],
  ["NFL", "American Football"],
]);

export const STATS_SELECTION = [
  {
    type: "season",
    name: "Season",
  },
  {
    type: "last5",
    name: "Last 5 Games",
  },
  {
    type: "last10",
    name: "Last 10 Games",
  },
  {
    type: "last20",
    name: "Last 20 Games",
  },
  {
    type: "h2h",
    name: "Head To Head",
  },
  {
    type: "homeaway",
    name: "Home/Away",
  },
];

export const DATES_MAP = new Map([
  ["today", "Today's Games"],
  ["tomorrow", "Tomorrow's Games"],
  ["3days", "Next 3 Days"],
  ["7days", "Next 7 Days"],
]);
